// extracted by mini-css-extract-plugin
export var cell = "_4o-4";
export var headerCell = "_4o-2";
export var rowHeader = "_4o-3";
export var table = "_4o-1";
export var tableContainer = "_4o-0";